<template>
  <div class="maxwidht">
    <!-- <div class="padding-sm">
      <div class="search_box">
        <img src="../assets/search.png" />
        <input placeholder="请输入商品名称" />
        <button>搜索</button>
      </div>
    </div> -->
    <div ref="swiperContainer" class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../assets/swiper1.jpg" alt="Slide Image" />
        </div>
        <div class="swiper-slide">
          <img src="../assets/swiper2.jpg" alt="Slide Image" />
        </div>
        <div class="swiper-slide">
          <img src="../assets/swiper3.jpg" alt="Slide Image" />
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

    </div>
    <div class="padding-sm">
      <div class="miaosha">
        <div>
          <img class="miaosha_img" src="../assets/xsms.png" />
          <div class="countdown">{{ formattedTime}}</div>
        </div>
        <div class="miaosha_goods">
          <div v-if="index<=2" v-for="(product,index) in products" :key="product.id"
          @click="addToCart(product)">
            <img class="goods_img" :src="product.picture_src" />
            <div class="goods_price">￥{{ product.price }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="zhekou">
      <div class="zhekou_left">
        <img src="../assets/gfsanzhe.png" />
      </div>
      <div class="zhekou_right">
        <div class="qixi">
          <div class="text-center">感恩节回馈</div>
          <div class="grid_zhekou">
            <div class="zhekou_box" v-if="index>2 && index<=4" v-for="(product,index) in products" :key="product.id"
            @click="addToCart(product)">
              <img class="goods_img" :src="product.picture_src" />
              <div class="goods_price">￥{{ product.price }}</div>
            </div>
          </div>
        </div>
        <div class="aoyun">
          <div class="text-center">冬季暖心特惠</div>
          <div class="grid_zhekou">
            <div class="zhekou_box" v-if="index>=4 && index<=6" v-for="(product,index) in products" :key="product.id"
            @click="addToCart(product)">
              <img class="goods_img" :src="product.picture_src" />
              <div class="goods_price">￥{{ product.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="socll_tab">
      <div class="item" v-for="item in items" :key="item.id" @click="selectItem(item)"
        :class="{ 'active': item.id === selectedId }">
        {{ item.name }}
      </div>
    </div> -->
    <div class="product-list">
      <div class="product-item" v-for="product in products" :key="product.id">
        <img :src="product.picture_src" :alt="product.product_name" class="product-image" @click="addToCart(product)">
        <h3 class="product-name">{{ product.product_name }}</h3>
        <p class="product-price">￥{{ product.price }}</p>
        <button class="add-to-cart-button" @click="addToCart(product)">立即购买</button>
      </div>
    </div>
    <!-- <div class="kefu">
      <img src="../assets/kefu.png" />
    </div> -->
    <div class="text-center ICP" v-html="ICPhtml">
      <!-- Copyright © 2021-2024 聚创(邯郸)文化传媒有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备20011305号-3</a> -->
    </div>
    <div class="nav-container">
      <div class="nav-item" v-for="item in menuItems" :key="item.label" @click="footerChange(item)">
        <img :src="item.icon"></img>
        <div class="label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getHomeGoods
  } from "../utils/api"
  // 引入 Swiper 核心组件
  import Swiper from 'swiper/bundle';
  // 引入 Swiper 样式
  import 'swiper/swiper-bundle.css';
  export default {
    data() {
      return {
        slides: ['../assets/swiper1.jpg', '../assets/swiper2.jpg', '../assets/swiper3.jpg'], // 图片数组
        swiper: null, // 用于保存 Swiper 实例
        products: [],
        cart: [],
        page: 1,
        touchBottom: false,
        selectedId: 1,
        menuItems: [{
            icon: require('../assets/home.png'),
            label: '首页'
          },
          {
            icon: require('../assets/fenlei.png'),
            label: '分类'
          },
          {
            icon: require('../assets/my.png'),
            label: '我的'
          }
        ],
        items: [{
            id: 1,
            name: '红酒'
          },
          {
            id: 2,
            name: '白酒'
          },
          {
            id: 3,
            name: '工艺品'
          },
          {
            id: 4,
            name: '收藏品'
          },
          {
            id: 5,
            name: ''
          },
          {
            id: 6,
            name: '类别4'
          },
          {
            id: 7,
            name: '类别5'
          },
          // Add more items as needed
        ],
        timeLeft: 1800,
        ICPhtml:'Copyright © 2021-2024 聚创(邯郸)文化传媒有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备20011305号-3</a>'
      };
    },
    created() {
      this.getGoodsList(); //获取商品列表
      var domain = window.location.hostname;
      console.log(domain,"我的域名")
      if(domain=='wl.bjczjy.cn'){
        this.ICPhtml = 'Copyright © 2021-2024 邯郸传正文化发展有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/?wm=vt1">冀ICP备19032043号-3</a>'
      }
    },
    computed: {
      formattedTime() {
        const hours = Math.floor(this.timeLeft / 3600);
        const minutes = Math.floor((this.timeLeft % 3600) / 60);
        const seconds = this.timeLeft % 60;

        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
      }
    },
    mounted() {
      // this.initSwiper();
      this.startCountdown();
      // window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      // window.removeEventListener('scroll', this.handleScroll);
    },
    filters: {
      currency(value) {
        return `$${value.toFixed(2)}`;
      }
    },
    methods: {
      //底部菜单栏
      footerChange(item){
        switch (item.label){
          case "分类":
            this.$router.push({
              name: 'itemize',
            })
            break;
          case "我的":
            this.$router.push({
              name: 'my',
            })
            break;
        }
        console.log(item,"sss")
      },
      //
      pad(number) {
        return number < 10 ? '0' + number : number;
      },
      startCountdown() {
        const interval = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--;
          } else {
            clearInterval(interval);
          }
        }, 1000);
      },
      selectItem(item) {
        this.selectedId = item.id;
      },
      handleScroll() {
        // 防抖函数
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          const pageHeight = document.documentElement.scrollHeight;
          const viewportHeight = window.innerHeight;
          const scrollPosition = window.scrollY || window.pageYOffset;

          // 当滚动位置加上视窗高度大于或等于页面高度时，触发触底事件
          if (scrollPosition + viewportHeight >= pageHeight) {
            this.handleScrollBottom();
          }
        }, 200); // 200毫秒的防抖时间
      },
      handleScrollBottom() {
        this.page++
        if (!this.touchBottom) {
          this.getGoodsList()
        }

        // 触底后需要执行的代码
      },
      getGoodsList() {
        getHomeGoods({
          page: this.page
        }).then(res => {
          if (res.data.length <= 0) {
            this.touchBottom = true;
          } else {
            this.products = this.products.concat(res.data);
            this.touchBottom = false;
          }

        })
      },
      addToCart(product) {
        this.$router.push({
          name: 'shopping',
          query: {
            code_id: product.landing_page_info_code,
            clickid:'2024'
          }
        })
        // 这里可以添加更多的逻辑，比如更新购物车显示、保存购物车状态等
      },
      initSwiper() {
        this.swiper = new Swiper(this.$refs.swiperContainer, {
          // Swiper options
          loop: true,
          autoplay: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // }
        });
      },
    },
    beforeDestroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true); // 销毁 Swiper 实例
      }
    },
  };
</script>

<style>
  .maxwidht {
    max-width: 500px;
    margin: 0 auto;
  }

  /* 你可以在这里添加自定义样式 */
  .swiper-wrapper {
    height: 25vh;
  }

  .swiper-slide img {
    width: 100%;
    height: 100%;
  }

  /* 商品列表 */
  .product-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-bottom: 60px;
  }

  .product-item {
    background-color: #fff;
    margin: 10px;
    padding: 10px;
    height: auto;
    border-radius: 5px;
    box-shadow: 0px 0px 6px -2px #888;
  }

  .product-image {
    width: 100%;
    height: 180px;
  }

  .product-name {
    margin: 10px 0;
    font-weight: bold;
    color: #000;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 限制行数 */
    overflow: hidden; /* 隐藏超出部分 */
    line-height: 1.5; /* 你可以根据需要设置行高 */
    max-height: calc(1.5em * 3); /* 计算最大高度，基于行高和行数 */
  }

  .product-price {
    color: red;
    font-weight: bold;
  }

  .add-to-cart-button {
    background-color: red;
    color: white;
    border: none;
    width: 100%;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 5px;
  }

  .add-to-cart-button:hover {
    background-color: darkblue;
  }

  .kefu {
    position: fixed;
    width: 80px;
    height: 100px;
    bottom: 10%;
    right: 2%;
  }

  .kefu img {
    width: 100%;
    height: 100%;
  }



  .socll_tab {
    width: 100%;
    /* Adjust the width as needed */
    overflow-x: auto;
    /* Enable horizontal scrolling */
    white-space: nowrap;
    /* Ensure items are in a single line */
    background-color: #fff;

    /* Hide scrollbar for IE, Edge, and Firefox */
    scrollbar-width: none;
    /* Firefox */

    /* Hide scrollbar for Chrome, Safari, and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
  }

  .item {
    display: inline-block;
    /* Inline-block for horizontal layout */
    padding: 10px;
    width: 15%;
    text-align: center;
    position: relative;
  }

  .item:hover,
  .item.active {
    color: #d33;
    font-weight: bold;
  }

  .item.active::after {
    content: '';
    position: absolute;
    bottom: -10px;
    /* Adjust based on your design */
    left: 50%;
    width: 40px;
    /* Width of the smile */
    height: 12px;
    /* Height of the smile */
    background-color: #d33;
    border-radius: 0 0 20px 20px;
    /* Creates the smile shape */
    transform: translateX(-50%);
  }

  .nav-container {
    display: flex;
    justify-content: space-around;
    background-color: #f8f9fa;
    padding: 10px 0;
    border-top: 1px solid #ccc;
    position: fixed;
    bottom: 0;
    width: 100%;
  }

  .nav-item {
    text-align: center;
    flex-grow: 1;

  }

  .nav-item img {
    width: 25px;
    height: 25px;
  }

  .icon {
    display: block;
    font-size: 24px;
    color: #333;
  }

  .label {
    font-size: 12px;
    color: #666;
  }

  .search_box {
    display: flex;
    align-items: center;
    border: 1px solid #FA2B19;
    padding: 5px;
    border-radius: 15px;
  }

  .search_box img {
    width: 20px;
    height: 20px;

  }

  .search_box input {
    flex: 1;
    border: none;
  }

  .search_box input:focus {
    outline: none;
    /* 移除聚焦时的轮廓线 */
    box-shadow: none;
    /* 移除聚焦时的阴影 */
    border: none;
    /* 设置你希望的边框样式 */
  }

  .search_box button {
    border: none;
    background-color: #FA2B19;
    color: #fff;
    border-radius: 15px;
  }

  .padding-sm {
    padding: 10px 5px;
  }

  /* 秒杀区样式 */
  .miaosha {
    background-image: url('../assets/miaoshabg.png');
    background-size: 100% 100%;
    padding: 10px;
    display: flex;
  }

  .miaosha_img {
    width: 100px;
    height: 100px;
  }

  .miaosha_goods {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    margin-left: 10px;
  }

  .goods_img {
    width: 100%;
    height: 100px;
  }

  .goods_price {
    text-align: center;
    color: #FA2B19;
    font-weight: bold;
    padding: 5px;
  }

  .countdown {
    background: linear-gradient(to bottom, #FCBAA0, #FB835C);
    color: #fff;
    border-radius: 15px;
    text-align: center;
    padding: 5px;
    font-weight: bold;
  }


  /* 折扣区 */
  .zhekou {
    display: flex;
    padding: 0px 5px 10px 5px;
  }

  .zhekou_left {
    width: 45%;
  }

  .zhekou_left img {
    width: 100%;
    height: 100%;
  }

  .text-center {
    text-align: center;
  }

  .zhekou_right {
    flex: 1;
    margin-left: 10px;
  }

  .qixi {
    border-radius: 5px;
    background: linear-gradient(to bottom, #FE829B, #FFB0C3);
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    padding: 10px;
  }

  .aoyun {
    border-radius: 5px;
    background: linear-gradient(to bottom, #AE8DFE, #CEB9FE);
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    padding: 10px;
    margin-top: 10px;
  }

  .grid_zhekou {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
  }
  .zhekou_box{
    background-color: #fff;
    border-radius: 5px;
    font-size: 12px;
  }
  .ICP{
    padding:10px 5px;
    font-size:14px;
    color:#7f7f7f;
    margin-bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shopIndex.vue